/**
 * Timeline — vertical activity timeline used in the Aktivität tab.
 * Ported from v0 kunden-view.tsx Historie TabsContent.
 *
 * Also the Posteingang's Aktivitätenhistorie: an event may carry rich text and an
 * `onClick` (a sent reply opens in place), which renders the row as a button.
 */
import type { ReactNode } from 'react';
import { History } from 'lucide-react';

export interface TimelineEvent {
  id: string;
  text: ReactNode;
  datum: string;
  /** When set, the whole row is a button (e.g. open the sent e-mail). */
  onClick?: () => void;
}

interface TimelineProps {
  events: TimelineEvent[];
  empty?: string;
}

export function Timeline({ events, empty = 'Keine Ereignisse.' }: TimelineProps) {
  if (events.length === 0) {
    return (
      <div className="rounded-lg border bg-card p-8 text-center text-sm text-muted-foreground">
        {empty}
      </div>
    );
  }
  return (
    <ol className="relative ml-2 flex flex-col gap-4 border-l pl-6">
      {events.map((h) => {
        const body = (
          <>
            <p className="text-sm text-foreground">{h.text}</p>
            <p className="flex items-center gap-1 text-xs text-muted-foreground">
              <History className="size-3" />
              {h.datum}
            </p>
          </>
        );
        return (
          <li key={h.id} className="relative">
            <span className="absolute -left-[1.65rem] top-1 flex size-3 items-center justify-center">
              <span className="size-2 rounded-full bg-muted-foreground" />
            </span>
            {h.onClick ? (
              <button
                type="button"
                onClick={h.onClick}
                className="-mx-1.5 block w-full rounded px-1.5 py-0.5 text-left hover:bg-accent [&>p:first-child]:hover:underline"
              >
                {body}
              </button>
            ) : (
              body
            )}
          </li>
        );
      })}
    </ol>
  );
}
